"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureContext = exports.DSFeature = exports.FeaturesProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var FeatureContext = react_1.createContext({});
exports.FeaturesProvider = FeatureContext.Provider;
var DSFeature = function (_a) {
    var _b;
    var name = _a.name, showChildren = _a.showChildren, children = _a.children;
    var flags = react_1.useContext(FeatureContext);
    if (!children)
        return null;
    if (showChildren && !flags[name])
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
    return ((_b = flags[name]) === null || _b === void 0 ? void 0 : _b.enabled) ? jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0) : null;
};
exports.DSFeature = DSFeature;
var useFeatureContext = function () { return react_1.useContext(FeatureContext); };
exports.useFeatureContext = useFeatureContext;
